<!--<div *ngIf="!modePro">
  <div class="auth-header"></div>
  <div class="auth-wrapper">
    <div id="standalone-page" role="backoffice-index">
      <div id="auth-wrapper" class="rp-xs fit-xs">
        <div class="">&lt;!&ndash; row &ndash;&gt;
          <div class="" > &lt;!&ndash; offset-md-3, offset-sm-2  &ndash;&gt;
            &lt;!&ndash;<div class="text-center my-5" *ngIf="!loggedIn()">
              <a [routerLink]="['/']"><img src="assets/imgs/{{logoName}}" alt="Logo Akces" id="logo"></a>
            </div>&ndash;&gt;
            <div class="container test">
              <router-outlet (messageEvent)="receiveMessage($event)"></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="auth-footer"></div>
</div>-->
<div *ngIf="!modePro">
  <router-outlet (messageEvent)="receiveMessage($event)"></router-outlet>
</div>

<!--<div *ngIf="modePro">
  <div>test</div>
</div>-->

<div *ngIf="modePro">
  <div *ngIf="!isProSignupProcessgoin()" class="{{isSignup?'screenMin768bg-p-left screenMax500bg-p-top bgImage col-md-12 pd-r-0p mlr-0 pd-l-0p row':'screenMin768bg-p-left screenMax500bg-p-top test'}}">
    <div class="row col-md-12 pd-r-0p mlr-0 pd-l-0p  {{isSignup?'':'h-100vh'}}">
      <div class="{{isSignup?'col-md-6 pd-l-0p pd-r-0p h-100-lg':'max-500-h-100 pd-r-0p max-500-p-l-0p max-500-p-r-0p col-md-5 min768pd-l-0 h-100'}}">
        <div class="{{isSignup?'pd-l-0p h-100-lg bg-color min768ModeProLogupPadding max500ModeProLogupPadding':'max-500-pd-48percent max-500-h-100 min768pd-l-0 min768ModeProLoginPadding pd-top-70p max500ModeProLoginPadding bg-color h-100'}}">
          <div class="text-center mb-20p" *ngIf="!loggedIn()">
            <a style="width: 250px" [routerLink]="['/']"><img src="assets/imgs/{{logoName}}" alt="Logo Akces" id="logo"></a>
          </div>
          <div class=" container {{isSignup?'min768padding1-90':''}}">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
      <div *ngIf="!isSignup" class="col-md-7 pd-l-0p pd-r-0p bgImagePro">

      </div>
      <div *ngIf="isSignup" class="col-md-6 pd-r-0p pd-l-0p bgcl-white">
        <h2 class="container mt-30p center max500fs-25 logUpIconAndTextColor text-center signup-title">
          <span>La solution de billetterie</span> <br>
          idéale pour <span class="proOrganiser"> vos <br> évènements !</span>
        </h2>
        <!--<div class="col-md-12 row center1 mb-60p">
          <div class="col-md-4 logUpIconAndTextColor"><span class="dot-1"></span>Lancez vous gratuitement </div>
          <div class="col-md-4 logUpIconAndTextColor"><span class="dot-1"></span>Publiez vos évènements</div>
          <div class="col-md-4 logUpIconAndTextColor"> <span class="dot-1"></span>Gerez vos participants</div>
        </div>-->
        <div class="col-md-10 mb-60p m-r-auto center1 m-top">
          <div class="logUpIconAndTextColor inline-block">Lancez vous gratuitement </div>
          <div class="logUpIconAndTextColor inline-block ml-6p"><span class="dot-1"></span>Publiez vos évènements</div>
          <div class="logUpIconAndTextColor inline-block ml-6p"> <span class="dot-1"></span>Gerez vos participants</div>
        </div>
        <div class="col-md-12 row center1">

          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"> <img src="../../../assets/imgs/icone-atelier.png" class="w-h-80p" /></div>
            <span class="icone-label">Atelier</span>
          </div>
          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"> <img src="../../../assets/imgs/icone-afterwork.png" class="w-h-80p h-80p center1" /></div>
            <span class="icone-label">Afterwork</span>
          </div>
          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"><img src="../../../assets/imgs/icone-dejeunerchampetre.png" class="w-h-80p center1" /></div>
            <span class="icone-label">Déjeuner champetre</span>
          </div>
          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"> <img src="../../../assets/imgs/icone-randonné.png" class="w-h-80p center1" /></div>
            <span class="icone-label">Randonné</span>
          </div>

          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"><img src="../../../assets/imgs/associatif.png" class="w-h-80p center1" /></div>
            <span class="icone-label">Evènement associatif</span>
          </div>
          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"> <img src="../../../assets/imgs/icone-soiree.png" class="w-h-80p center1" /></div>
            <span class="icone-label">Soirée</span>
          </div>
          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"> <img src="../../../assets/imgs/icone-concert.png" class="w-h-80p center1" /></div>
            <span class="icone-label">Concert</span>
          </div>
          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"><img src="../../../assets/imgs/icone-foire.png" class="w-h-80p center1" /></div>
            <span class="icone-label">Foire culinaire </span>
          </div>

          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"> <img src="../../../assets/imgs/conference.png" class="w-h-80p center1" /></div>
            <span class="icone-label">Conférences</span>
          </div>

          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"> <img src="../../../assets/imgs/icone-sportif.png" class="w-h-80p center1" /></div>
            <span class="icone-label">Evènement sportif</span>
          </div>

          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"> <img src="../../../assets/imgs/icone-festival.png" class="w-h-80p center1" /></div>
            <span class="icone-label">Festival</span>
          </div>
          <div class="min768width25 max500width33 max500mb67p min768mb48p">
            <div class="center-icon"><img src="../../../assets/imgs/icone-tournoi.png" class="w-h-80p center1" /></div>
            <span class="icone-label">Tournoi</span>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isProSignupProcessgoin() && isSignup">
    <router-outlet (messageEvent)="receiveMessage($event)"></router-outlet>
  </div>
</div>

<!--
<div class="auth-wrapper">
  <div id="standalone-page" role="backoffice-index">
    <div id="auth-wrapper" class="container rp-xs fit-xs">
      <div class="">&lt;!&ndash; row &ndash;&gt;
        <div class="all-div" > &lt;!&ndash; offset-md-3, offset-sm-2  &ndash;&gt;
          <div class="text-center my-5" *ngIf="!loggedIn()">
            <a [routerLink]="['/']"><img src="assets/imgs/{{logoName}}" alt="Logo Akces" id="logo"></a>
          </div>
          <div class="container test">
            <router-outlet (messageEvent)="receiveMessage($event)"></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>-->
